import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";

export const UtmTagSchema: FormFieldSchema[] = [
  {
    type: FormFieldType.Group,
    id: "utmTag",
    label: "UTM 태그",
    noneStyle: true,
    schemas: [
      {
        type: FormFieldType.Text,
        id: "campaign_id",
        defaultValue: "",
        label: "캠페인 아이디(ID)",
        description:
          "캠페인을 구분하기 위한 고유한 값을 입력해주세요.[mo] 예)1A45E",
        placeholder: "1A45E",
      },
      {
        type: FormFieldType.Text,
        id: "campaign_source",
        defaultValue: "",
        label: "캠페인 소스(Source)",
        description:
          "유입 소스가 발생한 매체를 입력해주세요.[mo] 예)shortsworks",
        placeholder: "shortsworks",
      },
      {
        type: FormFieldType.Text,
        id: "campaign_medium",
        defaultValue: "",
        label: "캠페인 미디엄(Medium)",
        description:
          "유입이 된 마케팅의 방법을 입력해주세요.[mo] 예)main_shorts",
        placeholder: "main_shorts",
      },
      {
        type: FormFieldType.Text,
        id: "campaign_name",
        defaultValue: "",
        label: "캠페인 이름(Campaign)",
        description:
          "캠페인을 구분하기 위한 고유한 값을 입력해주세요.[mo] 예)1A45E",
        placeholder: "summer_promotion",
      },
      {
        type: FormFieldType.Text,
        id: "campaign_content",
        defaultValue: "",
        label: "캠페인 콘텐츠(Content)",
        description:
          "유입이 진행된 게시글이나 페이지를 입력해주세요.[mo] 예)detail_page",
        placeholder: "detail_page",
      },
    ],
  },
];
